export default __webpack_public_path__ + "static/media/izi.b4148069.jpg";